import Button from "~/components/ui/Button";
import Icon from "~/components/ui/Icon";
import {
  DesktopFilters,
  MobileFilters,
  selectVisibleSearchFilters,
} from "~/components/search/Filters";
import { DesktopSort, MobileSort } from "~/components/search/Sort";
import Drawer from "~/components/ui/Drawer";
import { useSignal } from "~/sdk/signal";
import { useEffect } from "react";
import type { ProductListingPage } from "@decocms/apps-commerce/types";
export type Props = Pick<ProductListingPage, "filters" | "sortOptions"> & {
  productCount: number;
};

function SearchControls({
  filters,
  sortOptions,
  productCount,
}: Props) {
  const filterOpen = useSignal(false);
  const sortOpen = useSignal(false);

  const toggleFilters = selectVisibleSearchFilters(filters);

  useEffect(() => {
    if (globalThis.location.pathname !== "/1487") {
      return;
    }

    console.log("[PLP filters][new-in]", {
      path: globalThis.location.pathname,
      search: globalThis.location.search,
      rawFilters: filters,
      visibleFilters: toggleFilters,
    });
  }, [filters, toggleFilters]);

  const hasValuesWithQuantity = toggleFilters.some((
    filter,
  ) => filter.values.some((value) => value.quantity > 0));

  return (
    <>
      {/* flex-nowrap: filtros e o bloco de contagem/ordenação ficam sempre na
          MESMA linha (é assim que a barra foi desenhada). Os filtros (largura
          variável, achado 03 da auditoria de 23/08/2026) encolhem via min-w-0
          dentro de DesktopFilters em vez de empurrar este bloco pra linha de
          baixo. */}
      <div className="hidden lg:flex flex-nowrap items-center justify-between gap-x-[15px] xl:gap-x-[25px] bg-[#F0F0F0] min-h-[65px] py-[15px] px-[50px]">
        <DesktopFilters filters={toggleFilters} />
        {/* shrink-0: contagem + ordenação nunca são espremidas — os filtros é
            que absorvem a falta de espaço. */}
        <div className="flex items-center w-75 gap-[25px] shrink-0">
          {productCount && (
            <span className="w-full flex max-w-max font-['Poppins'] text-[10px] font-medium leading-[11px] tracking-[0.06em] text-[#333333]">
              {productCount} produtos
            </span>
          )}

          {sortOptions?.length > 0 && <DesktopSort sortOptions={sortOptions} />}
        </div>
      </div>

      <div className="lg:hidden bg-[#F0F0F0]">
        <Drawer // filter drawer
          className="filter-drawer"
          loading="lazy"
          open={filterOpen.value}
          onClose={() => (filterOpen.value = false)}
          aside={
            <>
              <div className="bg-base-100 flex flex-col h-full w-full divide-y">
                <div className="flex sticky top-0 z-50 justify-between items-center bg-[#F1F2E8]">
                  <span className="w-full my-[15px] flex justify-center font-['Poppins'] text-sm font-normal uppercase">
                    Filtrar
                  </span>
                  <Button
                    className="btn btn-ghost flex absolute right-[3px]"
                    onClick={() => (filterOpen.value = false)}
                    aria-label="Fechar filtros"
                  >
                    <Icon id="XMark" size={24} strokeWidth={2} />
                  </Button>
                </div>
                <div className="flex flex-col h-auto">
                  <MobileFilters filters={toggleFilters} />
                  <div className="sticky bottom-0 bg-white border-t-[1px] flex py-[15px] px-10 items-center font-['Poppins'] uppercase tracking-[3px] z-50">
                    <a
                      className="p-2.5 text-[#333333] text-xs font-['Poppins']"
                      href={`/${globalThis?.location?.pathname?.split("/")[1]}`}
                    >
                      <span className="clean">limpar filtros</span>
                    </a>
                  </div>
                </div>
              </div>
            </>
          }
        >
          <div className="flex flex-col items-center justify-around h-11">
            <div className="flex justify-around w-full mt-[5px]">
              {hasValuesWithQuantity && (
                <>
                  <Button
                    className={`btn-ghost text-base font-normal text-[#333333] ${
                      sortOptions?.length > 0 && "pl-[30px]"
                    }`}
                    onClick={() => {
                      filterOpen.value = true;
                    }}
                    aria-label="Filtrar"
                  >
                    Filtrar
                  </Button>
                  <span className="flex justify-center items-center h-[30px] bg-no-repeat p-0 w-0.5 bg-[url(/arquivos/icon__separator.png)]">
                  </span>
                </>
              )}

              {sortOptions?.length > 0 && (
                <>
                  <Button
                    className="btn-ghost text-base font-normal text-[#333333] pr-[30px]"
                    aria-label="Ordernar"
                    onClick={() => {
                      sortOpen.value = true;
                    }}
                  >
                    Ordenar
                  </Button>
                </>
              )}
            </div>

            {sortOptions?.length > 0 && (
              <Drawer // sort drawer
                className="drawer-end"
                loading="lazy"
                open={sortOpen.value}
                onClose={() => (sortOpen.value = false)}
                aside={
                  <>
                    <div className="bg-base-100 flex flex-col h-full w-full divide-y">
                      <div className="flex justify-between items-center bg-[#F1F2E8]">
                        <span className="w-full my-[15px] flex justify-center font-['Poppins'] text-base font-normal text-[#333333]">
                          Ordenar
                        </span>
                        <Button
                          className="btn btn-ghost flex absolute right-[3px]"
                          onClick={() => (sortOpen.value = false)}
                          aria-label="Fechar ordenação"
                        >
                          <Icon id="XMark" size={24} strokeWidth={2} />
                        </Button>
                      </div>
                      <div className="flex flex-col h-auto">
                        <MobileSort sortOptions={sortOptions} />
                      </div>
                    </div>
                  </>
                }
              >
                <></>
              </Drawer>
            )}
          </div>
        </Drawer>
      </div>
    </>
  );
}

export default SearchControls;
